import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { allApis } from "../../../request/config";
import apiRequest from "../../../request/apiRequest/apiRequest";
export interface StatusCounts {
  Completed: number;
  Pending: number;
}

export interface DeletionItem {
  id: number;
  action_type: string;
  options: string[];
  remark: string;
  type_id: number;
  type: string;
  status: string;
  created_by: number;
  created_at: string; // ISO timestamp
  created: string;
  modified_at: string; // ISO timestamp
  topic_name: string;
}

export interface DeletionListData {
  status_counts: StatusCounts;
  results: DeletionItem[];
}

export interface deletionsListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: DeletionListData;
}

// Define the initial state
interface pendingApprovalState {
  deletionsList: deletionsListResponse;
  loading: boolean;
  error: string | null;
}

const initialState: pendingApprovalState = {
  deletionsList: {
    count: 0,
    next: null,
    previous: null,
    results: {
      status_counts: {
        Completed: 0,
        Pending: 0,
      },
      results: [],
    },
  },
  loading: true,
  error: null,
};

// create get order list slice
export const fetchDeletionsList = createAsyncThunk(
  "pendingApproval/fetchDeletionsList",
  async (status:any) => {
    try {
      const query = allApis.bulk_delete(`?status=${status}`);
      const response: deletionsListResponse = await apiRequest({
        api: query,
        method: "GET",
      });
      return response;
    } catch (error: any) {
      throw new Error("Failed to fetch orders and payments list");
    }
  }
);

const pendingApprovalSlice = createSlice({
  name: "pendingApproval",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchStaffList
      .addCase(fetchDeletionsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDeletionsList.fulfilled, (state, action) => {
        state.loading = false;
        state.deletionsList = action.payload;
      })
      .addCase(fetchDeletionsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch list";
      });
  },
});

// export const {} = pendingApprovalSlice.actions;
export default pendingApprovalSlice.reducer;
